/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

var productForm = document.querySelectorAll(".atc-button");
productForm?.forEach(function(button) {
    button.addEventListener("click", function() {
        var productId = button.getAttribute('data-productId')

        console.log(productId);
        let formData = {
        'items': [{
            'id': productId,
            'quantity': 1
            }]
        };
        sidecart.quickAdd({ variant: productId });
    });
});


let all_bundle_save_btn = document.querySelectorAll('.bundle-and-save-btn');
if(all_bundle_save_btn.length > 0){
  all_bundle_save_btn.forEach((bundle_save_btn)=> {
    bundle_save_btn.addEventListener('click', (e)=> {
      e.preventDefault();
      document.querySelector('.bundle-and-save-btn.active').classList.remove('active');
      bundle_save_btn.classList.add('active');
    })
  })
}

function addAltTextToImages(images) {
    images.forEach(function (img) {
        if (!img.hasAttribute("alt")) {
            img.setAttribute("alt", "");
        } else if (img.alt.match(/.(jpg|jpeg|png|tif|tiff|bmp|gif)$/i)) {
            img.setAttribute("alt", "");
        }
    });
}

window.onload = function () {
    var images = document.querySelectorAll("img");
    addAltTextToImages(images);

    // Observe the body for changes
    var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
            if (mutation.type === "childList") {
                mutation.addedNodes.forEach(function (node) {
                    if (node.tagName === "IMG") {
                        addAltTextToImages([node]);
                    } else if (node.querySelectorAll) {
                        var newImages = node.querySelectorAll("img");
                        addAltTextToImages(newImages);
                    }
                });
            }
        });
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true
    });
};













